var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61201 3.66049C9.29465 3.60186 9.00318 3.80439 8.94277 4.11418C8.88235 4.42397 9.08551 4.72643 9.39424 4.78705C10.3238 4.96826 11.0415 5.68777 11.2234 6.62046V6.62112C11.2752 6.88961 11.5115 7.08481 11.7837 7.08481C11.8203 7.08481 11.8568 7.08147 11.894 7.07481C12.2027 7.01286 12.4058 6.71106 12.3454 6.40061C12.0739 5.00757 11.0016 3.93164 9.61201 3.66049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57073 1.33927C9.42201 1.31795 9.27262 1.36192 9.15378 1.45652C9.03161 1.55246 8.95526 1.69103 8.93866 1.84626C8.90348 2.16004 9.12988 2.44385 9.44325 2.47915C11.6044 2.72032 13.2841 4.40383 13.5271 6.57168C13.5596 6.86214 13.8033 7.08133 14.0941 7.08133C14.116 7.08133 14.1373 7.08 14.1592 7.07733C14.3112 7.06068 14.4467 6.98539 14.5423 6.86548C14.6372 6.74556 14.6804 6.59633 14.6631 6.44377C14.3604 3.73896 12.267 1.63973 9.57073 1.33927Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35466 8.64826C10.014 11.3069 10.6173 8.23115 12.3106 9.92321C13.943 11.5552 14.8812 11.8821 12.813 13.9498C12.5539 14.158 10.9079 16.6628 5.12323 10.8798C-0.662156 5.096 1.84122 3.4483 2.04948 3.1893C4.12274 1.1159 4.44407 2.05959 6.07649 3.69155C7.76974 5.38433 4.69527 5.98961 7.35466 8.64826Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUpdate);
export default __webpack_public_path__ + "static/media/callUpdate.9aa0ec7ffb5055454729c00ce2c634e8.svg";
export { ForwardRef as ReactComponent };